var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3908 18.5051C24.8088 16.8682 25.6667 14.7329 25.6667 12.3972C25.6667 7.24252 21.4881 3.06384 16.3334 3.06384C11.1787 3.06384 7.00006 7.24252 7.00006 12.3972C7.00006 14.6277 7.78249 16.6754 9.08786 18.281L7.71736 25.2133C7.52846 26.1689 7.87555 27.1514 8.62275 27.7762C9.36995 28.401 10.3984 28.5688 11.3054 28.2137L16.3436 26.2416L21.3614 28.2057C22.2733 28.5626 23.3075 28.391 24.0552 27.7587C24.803 27.1264 25.1441 26.1351 24.9436 25.1766L23.5172 18.3561C23.4756 18.4062 23.4334 18.4559 23.3908 18.5051ZM23.0001 12.3972C23.0001 16.0791 20.0153 19.0638 16.3334 19.0638C12.6515 19.0638 9.66673 16.0791 9.66673 12.3972C9.66673 8.71528 12.6515 5.73051 16.3334 5.73051C20.0153 5.73051 23.0001 8.71528 23.0001 12.3972ZM21.2111 20.3561C19.7917 21.2278 18.1212 21.7305 16.3334 21.7305C14.5231 21.7305 12.8332 21.2151 11.4024 20.3231L10.3334 25.7305L15.6971 23.631C16.1133 23.4681 16.574 23.4681 16.9902 23.631L22.3334 25.7225L21.2111 20.3561Z",
    fill: "url(#paint0_linear_1387_13932)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1387_13932",
    x1: 7.00006,
    y1: 22.3172,
    x2: 26.4193,
    y2: 20.9277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05456D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertIcon);
export default __webpack_public_path__ + "static/media/cert-icon.aac92c98ac134b6489f4773a3d68f660.svg";
export { ForwardRef as ReactComponent };